import gql from 'graphql-tag'

export const newGroup = gql`
  mutation newGroup(
    $name: String!
    $startedAt: DateTime
    $completedAt: DateTime
    $minutesTotal: Int
    $isStared: Boolean
    $isDuration: Boolean
    $isPublic: Boolean
    $isCompleted: Boolean
    $color: String
    $type: String
    $userId: ID!
  ) {
    createGroup(
      name: $name
      startedAt: $startedAt
      completedAt: $completedAt
      minutesTotal: $minutesTotal
      isStared: $isStared
      isDuration: $isDuration
      isPublic: $isPublic
      isCompleted: $isCompleted
      color: $color
      type: $type
      userId: $userId
    ) {
      id
    }
  }
`

export const updateGroup = gql`
  mutation updateGroup(
    $name: String!
    $startedAt: DateTime
    $completedAt: DateTime
    $minutesTotal: Int
    $isStared: Boolean
    $isDuration: Boolean
    $isPublic: Boolean
    $isCompleted: Boolean
    $color: String
    $type: String
    $id: ID!
    $userId: ID!
  ) {
    updateGroup(
      name: $name
      startedAt: $startedAt
      completedAt: $completedAt
      minutesTotal: $minutesTotal
      isStared: $isStared
      isDuration: $isDuration
      isPublic: $isPublic
      isCompleted: $isCompleted
      color: $color
      type: $type
      id: $id
      userId: $userId
    ) {
      id
    }
  }
`

export const updateCompleteGroup = gql`
  mutation updateCompleteGroup($isCompleted: Boolean, $id: ID!, $userId: ID!) {
    updateGroup(isCompleted: $isCompleted, id: $id, userId: $userId) {
      id
    }
  }
`

export const deleteGroup = gql`
  mutation deleteGroup($id: ID!) {
    deleteGroup(id: $id) {
      id
    }
  }
`
export const addToTrackersOnGroup = gql`
  mutation addToTrackersOnGroup($groupsGroupId: ID!, $trackersTrackerId: ID!) {
    addToTrackersOnGroup(
      groupsGroupId: $groupsGroupId
      trackersTrackerId: $trackersTrackerId
    ) {
      groupsGroup {
        id
      }
    }
  }
`
export const addToGroupsOnGroup = gql`
  mutation addToGroupsOnGroup($groups1GroupId: ID!, $groups2GroupId: ID!) {
    addToGroupsOnGroup(
      groups1GroupId: $groups1GroupId
      groups2GroupId: $groups2GroupId
    ) {
      groups1Group {
        id
      }
    }
  }
`

export const removeFromTrackersOnGroup = gql`
  mutation removeFromTrackersOnGroup(
    $groupsGroupId: ID!
    $trackersTrackerId: ID!
  ) {
    removeFromTrackersOnGroup(
      groupsGroupId: $groupsGroupId
      trackersTrackerId: $trackersTrackerId
    ) {
      groupsGroup {
        id
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/graphql/mutations/group.js